import { Component, Injector, OnInit } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TermsMaintenanceService } from '../../service/terms-maintenance.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-terms-maintenance',
  templateUrl: './terms-maintenance.component.html',
  styleUrls: ['./terms-maintenance.component.scss']
})
export class TermsMaintenanceComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.TermsMaintenance;
  currentLang: string = this.laasSetting.language;
  laasTermsContent: string;
  termsTitle: string;
  uuid: string;
  languageOptions: any[] = [];
  termsForm: FormGroup;
  submitted: boolean;
  language: string;
  showTerms: boolean= false;
  contentView: string='';

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private termsMaintenanceService: TermsMaintenanceService
  ) {
    super(injector);
    this.laasTermsContent = "";
    this.termsTitle = "";
    this.uuid = "";
    this.language = 'zh-tw';
    this.submitted = false;

    this.translateService.get('Common.Language.EnUs').subscribe((translated: string) =>{
      this.languageOptions = [
        { label: this.translateService.instant('Common.Language.ZhTw'), value: 'zh-tw' },
        { label: this.translateService.instant('Common.Language.ZhCn'), value: 'zh-cn' },
        { label: this.translateService.instant('Common.Language.EnUs'), value: 'en-us' }
      ];
    });

    this.termsForm = this.fb.group({
      newTermsContent: ["", Validators.required]
    });
   }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    var Obj: any = {
      termsContent: "",
      termsTitle: 'laasTerms',
      uuid: this.uuid,
      createUser: this.userProfile.userName,
      language : 'zh-tw',
      status:'S'
    };


    this.termsMaintenanceService.getTerms(Obj).subscribe({
      next: result => {
        this.laasTermsContent = result.laasTermsContent;
      }
    });

  }

  announcementBtnClick(event: any) {
    this.confirmationService.confirm({
      message: this.translateService.instant('Terms.Maintenance.Confirm.Announcement'),
      header: this.translateService.instant('Terms.Maintenance.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.updateTerms('A');
      }
    })
  }

  updateTerms(status: string): void{

    this.submitted = true;
    var Obj: any = {
      termsContent: this.laasTermsContent,
      termsTitle: 'laasTerms',
      uuid: this.uuid,
      createUser: this.userProfile.userName,
      language:this.language,
      status:status
    };

    this.termsMaintenanceService.updateTerms(Obj).subscribe({
      next: result => {
        if(status == 'S'){
          this.toastService.success('儲存成功');
        }else{
          this.toastService.success('發布成功');
        }
      }
    });

  }
  view(): void {
    this.showTerms = true;
    this.contentView = this.laasTermsContent ;
    }

    // convenience getter for easy access to form fields
    get f() { return this.termsForm.controls; }

    languageChange(event: any): void {
      this.language =event.value
      var Obj: any = {
        termsContent: "",
        termsTitle: 'laasTerms',
        uuid: this.uuid,
        createUser: this.userProfile.userName,
        language : event.value,
        status:'S'
      };
      this.termsMaintenanceService.getTerms(Obj).subscribe({
        next: result => {
          this.laasTermsContent = result.laasTermsContent;
        }
      });

    }

    closeDialog(event: any): void {
      this.showTerms = false;
    }

    save(event: any) {
      this.confirmationService.confirm({
        message: this.translateService.instant('Terms.Maintenance.Confirm.Save'),
        header: this.translateService.instant('Terms.Maintenance.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.updateTerms('S');
        }
      })
    }

}
